"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumEventAction = exports.TealiumComponent = exports.TealiumFormat = exports.TealiumAction = exports.LATERAL_BANNER_CLICK_BUTTON = exports.LATERAL_BANNER_VIEW = void 0;
exports.LATERAL_BANNER_VIEW = 'LATERAL_BANNER_VIEW';
exports.LATERAL_BANNER_CLICK_BUTTON = 'LATERAL_BANNER_CLICK_BUTTON';
var TealiumAction;
(function (TealiumAction) {
    TealiumAction["OPEN"] = "open";
    TealiumAction["VIEW"] = "view";
})(TealiumAction || (exports.TealiumAction = TealiumAction = {}));
var TealiumFormat;
(function (TealiumFormat) {
    TealiumFormat["BANNER"] = "banner";
    TealiumFormat["BUTTON"] = "button";
})(TealiumFormat || (exports.TealiumFormat = TealiumFormat = {}));
var TealiumComponent;
(function (TealiumComponent) {
    TealiumComponent["BANNER"] = "banner";
})(TealiumComponent || (exports.TealiumComponent = TealiumComponent = {}));
var TealiumEventAction;
(function (TealiumEventAction) {
    TealiumEventAction["VIEW_BANNER"] = "viewBanner";
    TealiumEventAction["CLICK_BUTTON"] = "clickButton";
})(TealiumEventAction || (exports.TealiumEventAction = TealiumEventAction = {}));
//# sourceMappingURL=actions.js.map